'use strict';
angular.module('schoolLinqApp').factory('roleService', [
	'$http',
	function ($http) {
		var endpoint = '/api/role';

		function listSiteClaims() {
			return $http.get(endpoint + '/siteClaims');
		}

		function list() {
			return $http.get(endpoint + '/list');
		}

		function get(Id) {
			return $http.get(endpoint, { params: { Id: Id } });
		}

		// EndpointEnum: UpdateRole
		function update(role) {
			return $http.post(endpoint, role);
		}

		// EndpointEnum: UpdateRole
		function add(role) {
			return $http.put(endpoint, role);
		}

		// EndpointEnum: UpdateRole
		function deleteRole(Id) {
			return $http.delete(endpoint, { params: { Id: Id } });
		}

		return {
			listSiteClaims: listSiteClaims,
			list: list,
			get: get,
			update: update,
			add: add,
			deleteRole: deleteRole,
		};
	},
]);
